/* eslint-disable complexity */
import { useState } from "react";

// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { token } from "@atlaskit/tokens";

import { Logo } from "../../../../libraries/wpl/foundations/src/index";

//Types
type ProductType =
    | "atlas"
    | "compass"
    | "confluence"
    | "jiraproductdiscovery"
    | "jiraservicemanagement"
    | "jirasoftware"
    | "trello";

interface ProductNames {
    atlas: string;
    compass: string;
    confluence: string;
    jiraproductdiscovery: string;
    jiraservicemanagement: string;
    jirasoftware: string;
    trello: string;
}

const Products: ProductNames = {
    atlas: "Atlas",
    compass: "Compass",
    confluence: "Confluence",
    jiraproductdiscovery: "Jira Product Discovery",
    jiraservicemanagement: "Jira Service Management",
    jirasoftware: "Jira Software",
    trello: "Trello"
};

export interface ProductDetails {
    href: string;
    product: ProductType;
    description: string;
}

export interface ProductCardProps {
    productDetails: ProductDetails;
    className?: string;
    testId?: string;
}

export const ProductCard = ({
    productDetails,
    className,
    testId
}: ProductCardProps) => {
    const [isMouseOver, setMouseOver] = useState(false);

    const panelStyle = css`
        margin-bottom: ${token("space.250")};
        text-decoration: none;
    `;
    // TODO: adjust logo sizing when support is added for it
    const iconStyle = css`
        background-color: ${isMouseOver ? "#c1c7d0" : "#dfe1e5"};
        margin-right: ${token("space.250")};
        border-radius: ${token("space.025")};
        padding: ${token("space.050")} ${token("space.050")} 0
            ${token("space.050")};
    `;
    const titleStyle = css`
        color: ${isMouseOver ? "#0052cc" : "#091e42"};
        font-size: ${token("space.200")};
    `;
    const descriptionStyle = css`
        color: #505f79;
        font-size: ${token("space.150")};
    `;

    return (
        <div className={className} css={panelStyle}>
            <a
                href={productDetails.href}
                target={productDetails.product === "trello" ? "_blank" : ""}
                rel="noreferrer"
                data-event="clicked"
                data-event-component="linkButton"
                data-event-container="globalNavWacDropdownContainer"
            >
                <div
                    onMouseEnter={() => setMouseOver(true)}
                    onMouseLeave={() => setMouseOver(false)}
                    css={css`
                        display: inline-flex;
                        align-items: center;
                    `}
                    data-testid={testId}
                >
                    <div css={iconStyle} data-testid="icon">
                        <Logo
                            brand={productDetails.product}
                            type="mark"
                            appearance="brand"
                        />
                    </div>
                    <div>
                        <div css={titleStyle} data-testid="title">
                            {Products[productDetails.product]}
                        </div>
                        <div css={descriptionStyle}>
                            {productDetails.description}
                        </div>
                    </div>
                </div>
            </a>
        </div>
    );
};
